<style lang="scss">
@import '~scss/_variables';

.button-animated {
    position: relative;
    outline: none;

    .button-content {
        position: absolute;
            top: 50%;
            left: 50%;
            z-index: 1;
        transform: translate(-50%, -50%);
    }

    svg {
        width: 100%;
        height: 100%;
        overflow: visible !important;
        pointer-events: none !important;

        fill: $color-start-button;
        transform: scale(0.5) translate(50%, 50%);

        circle:not(:first-child) {
            opacity: 0.7;
        }
    }
}
</style>

<template>
    <button class="button-animated">
        <div class="button-content">
            <slot></slot>
        </div>
        <svg>
            <circle
                v-for="(circle, index) in circles"
                :key="index"
                :cx="circle[1] + '%'"
                :cy="circle[2] + '%'"
                r="100%"
            >
                <animateTransform
                    attributeType="xml"
                    attributeName="transform"
                    type="rotate"
                    :from="(circle[0] === 'cw') ? '0' : '360'"
                    :to="(circle[0] === 'cw') ? '360' : '0'"
                    :dur="circle[3]"
                    repeatCount="indefinite"
                />
            </circle>
        </svg>
    </button>
</template>

<script>
export default {
    props: {
        offset: {
            type: Number,
            default: 8
        }
    },
    computed: {
        circles () {
            return [
                ['cw', 0, 0, '0s'],
                ['cw', -this.offset, 0, '1.5s'],
                ['ccw', this.offset, 0, '2s'],
                ['cw', 0, -this.offset, '3s'],
                ['ccw', 0, this.offset, '2.5s']
            ];
        }
    }
};
</script>
